import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/authContext';
import ThemeToggle from './ThemeToggle';
import './MoreSheet.css';

/**
 * Mobile "More" bottom sheet — the long-tail menu that replaces the old
 * sidebar drawer. Opened from the bottom nav's "More" tab. Holds account
 * links, settings, the theme toggle, admin (for staff) and logout.
 */
const MoreSheet = ({ isOpen, onClose }) => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const isAdmin = user && (user.isAdmin || user.role === 'admin' || user.role === 'owner' || user.isOwner);

  if (!isOpen) return null;

  const onLogout = () => {
    localStorage.removeItem('userMatchCounts');
    logout();
    onClose();
    window.location.reload();
  };

  return (
    <div className="more-sheet" role="dialog" aria-modal="true">
      <div className="more-sheet__scrim" onClick={onClose} />
      <div className="more-sheet__panel">
        <div className="more-sheet__handle" />

        {isAuthenticated ? (
          <>
            <div className="more-sheet__user">
              <span className="more-sheet__avatar">
                {user?.pokemonSprite
                  ? <img src={user.pokemonSprite} alt="" />
                  : <i className="fas fa-user" />}
              </span>
              <div>
                <div className="more-sheet__name">{user?.name}</div>
                <div className="more-sheet__sub">@{user?.username}</div>
              </div>
            </div>

            <Link className="more-sheet__item" to="/profile-settings" onClick={onClose}><i className="fas fa-user-cog" /> Profile &amp; Settings</Link>
            <Link className="more-sheet__item" to="/friends" onClick={onClose}><i className="fas fa-users" /> Friends</Link>
            <Link className="more-sheet__item" to="/patch-notes" onClick={onClose}><i className="fas fa-code-branch" /> Patch Notes</Link>
            <Link className="more-sheet__item" to="/api-docs" onClick={onClose}><i className="fas fa-book" /> API Docs</Link>
            <Link className="more-sheet__item" to="/support" onClick={onClose}><i className="fas fa-headset" /> Support</Link>
            <a className="more-sheet__item" href="https://discord.gg/CWe3CtaCCs" target="_blank" rel="noopener noreferrer" onClick={onClose}><i className="fab fa-discord" /> Discord</a>
            <div className="more-sheet__row"><span><i className="fas fa-adjust" /> Dark mode</span><ThemeToggle /></div>

            {isAdmin && (
              <>
                <div className="more-sheet__divider" />
                <Link className="more-sheet__item more-sheet__item--admin" to="/admin" onClick={onClose}><i className="fas fa-shield-halved" /> Admin</Link>
              </>
            )}
            <div className="more-sheet__divider" />
            <button className="more-sheet__item more-sheet__item--danger" onClick={onLogout}><i className="fas fa-sign-out-alt" /> Log out</button>
          </>
        ) : (
          <>
            <Link className="more-sheet__item" to="/login" onClick={onClose}><i className="fas fa-sign-in-alt" /> Login</Link>
            <Link className="more-sheet__item" to="/register" onClick={onClose}><i className="fas fa-user-plus" /> Register</Link>
            <Link className="more-sheet__item" to="/patch-notes" onClick={onClose}><i className="fas fa-code-branch" /> Patch Notes</Link>
            <a className="more-sheet__item" href="https://discord.gg/CWe3CtaCCs" target="_blank" rel="noopener noreferrer" onClick={onClose}><i className="fab fa-discord" /> Discord</a>
            <div className="more-sheet__row"><span><i className="fas fa-adjust" /> Dark mode</span><ThemeToggle /></div>
          </>
        )}
      </div>
    </div>
  );
};

export default MoreSheet;
